// test370
(370 && 0);
